import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'mai-smartphone-button',
  imports: [],
  templateUrl: './smartphone-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmartphoneButton {
  readonly active = input(false, { transform: booleanAttribute });
}
